module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@3x-750b2b3b8d920749558915ecb670d15d.jpg";